import SEO from '@/components/base/SEO';
import SchemaOrg from '@/components/base/SchemaOrg';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import FeaturedArticles from './components/FeaturedArticles';
import LatestArticles from './components/LatestArticles';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

const siteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '黑料社区',
  url: 'https://heiliaoshequ.com',
  description: '黑料社区官网是用户获取真实内容、参与社区讨论的官方平台入口。',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://heiliaoshequ.com/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

const orgSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '黑料社区',
  url: 'https://heiliaoshequ.com',
  description: '真实内容社区平台',
};

export default function Home() {
  return (
    <>
      <SEO
        title="黑料社区官网 - 官方入口与核心功能指南 | 真实内容社区平台"
        description="黑料社区官网是用户获取真实内容、参与社区讨论的官方平台入口。涵盖社会热点、娱乐八卦、行业揭秘等多元话题，提供安全可靠的社区交流环境与最新资讯服务。"
        keywords="黑料社区官网,黑料社区官网入口,黑料社区官方网站,黑料社区最新地址,黑料社区怎么进,黑料社区官网访问教程"
        canonicalUrl="https://heiliaoshequ.com"
      />
      <SchemaOrg type="WebSite" data={siteSchema} />
      <SchemaOrg type="Organization" data={orgSchema} />

      <main>
        <Navbar />
        <HeroSection />
        <CategoryGrid />
        <FeaturedArticles />
        <LatestArticles />
        <FAQSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}